module.exports = __webpack_public_path__ + "static/img/js1.8453270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/js1.png
// module id = aCvO
// module chunks = 1